// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-list {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.settings-list__table {
    height: calc(100vh - 12.6rem);
    overflow: auto;
}

.settings-list-table th {
    padding-left: 20px;
    text-align: left !important;
}

.settings-list-table td {
    text-align: left !important;
    width: 40%;
}

.setting-create-button {
    float: left;
    margin: 1.65rem 4rem;
}

.setting-search-string {
    margin: 1.5rem 4rem;
    height: 4rem;
    line-height: 4rem;
}

.setting-delete-button {
    background-color: #d22e35;
    margin-left: .5rem;
}

.setting-buttons-container {
    display: flex;
    justify-content: flex-end;
    padding-right: 2rem;
}

.setting-cancel-button {
    background-color: #d22e37;
    float: left;
    margin: 1.65rem 4rem;
    margin-left: -2rem;
}

.setting-id-container {
    padding-left: 20px;
}

.is-invalid {
    border-bottom: 1px solid red !important;
}

.is-invalid:focus{
    box-shadow: 0 1px 0 0 red !important;
}


    .editing-setting-id input[type="text"] {
        height: auto;
        padding-bottom: 5px;
        line-height: 1.5;
        margin-top: 16px !important;
    }`, "",{"version":3,"sources":["webpack://./src/app/setting/settings-main/settings-list/SettingsList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;;IAGI;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,2BAA2B;IAC/B","sourcesContent":[".settings-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.settings-list__table {\r\n    height: calc(100vh - 12.6rem);\r\n    overflow: auto;\r\n}\r\n\r\n.settings-list-table th {\r\n    padding-left: 20px;\r\n    text-align: left !important;\r\n}\r\n\r\n.settings-list-table td {\r\n    text-align: left !important;\r\n    width: 40%;\r\n}\r\n\r\n.setting-create-button {\r\n    float: left;\r\n    margin: 1.65rem 4rem;\r\n}\r\n\r\n.setting-search-string {\r\n    margin: 1.5rem 4rem;\r\n    height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.setting-delete-button {\r\n    background-color: #d22e35;\r\n    margin-left: .5rem;\r\n}\r\n\r\n.setting-buttons-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding-right: 2rem;\r\n}\r\n\r\n.setting-cancel-button {\r\n    background-color: #d22e37;\r\n    float: left;\r\n    margin: 1.65rem 4rem;\r\n    margin-left: -2rem;\r\n}\r\n\r\n.setting-id-container {\r\n    padding-left: 20px;\r\n}\r\n\r\n.is-invalid {\r\n    border-bottom: 1px solid red !important;\r\n}\r\n\r\n.is-invalid:focus{\r\n    box-shadow: 0 1px 0 0 red !important;\r\n}\r\n\r\n\r\n    .editing-setting-id input[type=\"text\"] {\r\n        height: auto;\r\n        padding-bottom: 5px;\r\n        line-height: 1.5;\r\n        margin-top: 16px !important;\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
